import { __ } from '../translations/localization'
import Autocomplete from './Autocomplete'
import BarCharts from './BarCharts'
import PieCharts from './PieCharts'
import DateTimePicker from './DateTimePicker'
import Modal from './Modal'
import RequestButton from './RequestButton'
import _ from 'lodash'
import Datatable from '@western-investment/vue-datatable'

export default {
  install (Vue) {
    Vue.use(Datatable, {
      lang: {
        searchText: __('Search'),
        filterText: __('Filter'),
        clearFiltersText: __('Clear filters'),
        nextText: __('Next'),
        prevText: __('Previous'),
        noDataText: __('No results')
      }
    })

    Vue.component('BarCharts', BarCharts)
    Vue.component('PieCharts', PieCharts)
    Vue.component('Autocomplete', Autocomplete)
    Vue.component('DateTimePicker', DateTimePicker)
    Vue.component('modal', Modal)
    Vue.component('RequestButton', RequestButton)

    Vue.prototype.setErrorsFromResponse = function (response) {
      if (response.response.status === 400) {
        let errors = response.response.data.errors

        _.each(errors, (error, field) => {
          this.errors.add({ field, msg: error[0] })
        })
      }
    }
  }
}
